import React, { useEffect, useRef, useState } from "react";
import { ArrowIcon } from "../../Assets/assets";

export default function FilterCarousal({ children }) {
  const containerRef = useRef(null);
  const [canScroll, setCanScroll] = useState({ left: false, right: true });
  const [isScrollable, setIsScrollable] = useState(false);

  const updateScrollState = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      const needsScroll = scrollWidth > clientWidth;

      setIsScrollable(needsScroll);
      setCanScroll({
        left: needsScroll && scrollLeft > 0,
        right: needsScroll && scrollLeft < scrollWidth - clientWidth
      });
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      updateScrollState();
      container.addEventListener("scroll", updateScrollState);
    }
    window.addEventListener("resize", updateScrollState);

    return () => {
      if (container) {
        container.removeEventListener("scroll", updateScrollState);
      }
      window.removeEventListener("resize", updateScrollState);
    };
  }, []);

  const scroll = (direction) => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: direction === "left" ? -100 : 100,
        behavior: "smooth"
      });
    }
  };

  return (
    <div
      style={{
        width: "100%"
      }}
      className="display-flex flex-align-items-center hide-scrollbar"
    >
      {(isScrollable || canScroll.left || canScroll.right) && (
        <div
          className={`${
            !canScroll.left ? "cursor-no-drop half-opacity" : "cursor-pointer"
          }`}
          style={{
            transform: "rotate(90deg)",
            marginRight: "16px",
            marginLeft: "16px"
          }}
          onClick={() => scroll("left")}
        >
          <ArrowIcon color="var(--tertiaryColor6)" />
        </div>
      )}
      <div
        ref={containerRef}
        style={{
          overflowX: "scroll",
          overflowY: "hidden"
        }}
        className="inherit-parent-width hide-scrollbar"
      >
        {children}
      </div>
      {(isScrollable || canScroll.left || canScroll.right) && (
        <div
          className={`${
            !canScroll.right ? "cursor-no-drop half-opacity" : "cursor-pointer"
          }`}
          style={{
            transform: "rotate(270deg)",
            marginLeft: "16px",
            marginRight: "16px"
          }}
          onClick={() => {
            scroll("right");
          }}
        >
          <ArrowIcon color="var(--tertiaryColor6)" />
        </div>
      )}
    </div>
  );
}
